import { useField, useFormikContext } from 'formik'
import { useEffect } from 'react'

interface IProps {
    name: string,
}

export function DPTextTrimBehavior(props: IProps) {
    const { setFieldValue } = useFormikContext()
    const [field] = useField(props.name)

    useEffect(() => {
        const current = field.value
        if(typeof(current) !== 'string'){
            return
        }

        const trimmed = current?.trim()
        if(trimmed === current){
            return
        }
        
        setFieldValue(props.name, trimmed)
    }, [field.value])

    return null
}